export const ImageGameLogEvent = {
  HOME_IMAGE_GAME_IMPRESSION: {
    ga: 'impression',
    amp: 'Home - Image Game Impression',
  }, // [홈 탭] 이미지 게임 배너 노출됨
  HOME_IMAGE_GAME_CLICKED: {
    ga: 'home_Image_game_click',
    amp: 'Home - Image Game Clicked',
  }, // [홈 탭] 이미지 게임 배너 클릭
  MENU_SERVICE_ITEM_CLICKED: {
    ga: 'click_item',
    amp: 'Menu - Service Item Clicked',
  }, // [메뉴 탭] 이미지 게임 버튼 클릭
  IMAGE_GAME_QUIZ_CREATE_INTRO_VIEWED: {
    ga: 'image_game_quiz_create_intro_visit',
    amp: 'Image Game Quiz Create - Intro Viewed',
  }, // [이미지 게임 - 퀴즈 생성] 인트로 화면 조회
  IMAGE_GAME_QUIZ_CREATE_NAME_ENTRY_VIEWED: {
    ga: 'image_game_quiz_create_name_entry_visit',
    amp: 'Image Game Quiz Create - Name Entry Viewed',
  }, // [이미지 게임 - 퀴즈 생성] 이름 입력 화면 조회
  IMAGE_GAME_QUIZ_CREATE_MY_NAME_ENTERED: {
    ga: 'image_game_quiz_create_my_name_entered',
    amp: 'Image Game Quiz Create - My Name Entered',
  }, // [이미지 게임 - 퀴즈 생성] 생성자 이름 입력
  IMAGE_GAME_QUIZ_CREATE_USER_ADDED: {
    ga: 'image_game_quiz_create_user_added',
    amp: 'Image Game Quiz Create - User Added',
  }, // [이미지 게임 - 퀴즈 생성] 유저 등록
  IMAGE_GAME_QUIZ_CREATE_QUESTIONNAIRE_VIEWED: {
    ga: 'image_game_quiz_create_questionnaire_visit',
    amp: 'Image Game Quiz Create - Questionnaire Viewed',
  }, // [이미지 게임 - 퀴즈 생성] 질문지 화면 조회
  IMAGE_GAME_QUIZ_CREATE_ANSWER_SELECT_CLICKED: {
    ga: 'image_game_quiz_create_answer_clicked',
    amp: 'Image Game Quiz Create - Answer Select Clicked',
  }, // [이미지 게임 - 퀴즈 생성] 답변 선택
  IMAGE_GAME_QUIZ_CREATE_QUESTION_CHANGE_CLICKED: {
    ga: 'image_game_quiz_create_question_change_clicked',
    amp: 'Image Game Quiz Create - Question Change Clicked',
  }, // [이미지 게임 - 퀴즈 생성] ‘질문 변경’ 클릭
  IMAGE_GAME_QUIZ_CREATE_QUESTION_EDIT_CLICKED: {
    ga: 'image_game_quiz_create_question_edit_clicked',
    amp: 'Image Game Quiz Create - Question Edit Clicked',
  }, // [이미지 게임 - 퀴즈 생성] ‘질문 만들기’ 클릭
  IMAGE_GAME_QUIZ_CREATE_QUESTION_EDIT_SUBMIT: {
    ga: 'image_game_quiz_create_question_edit_submit',
    amp: 'Image Game Quiz Create - Question Edit Submit',
  }, // [이미지 게임 - 퀴즈 생성] ‘질문 만들기’ 입력 완료
  IMAGE_GAME_QUIZ_CREATE_QUIZ_CREATE_SUBMIT: {
    ga: 'image_game_quiz_create_submit',
    amp: 'Image Game Quiz Create - Quiz Create Submit',
  }, // [이미지 게임 - 퀴즈 생성] 퀴즈 생성 완료
  IMAGE_GAME_REPLY_CREATE_SELECT_PROFILE_VIEWED: {
    ga: 'image_game_reply_create_select_profile_visit',
    amp: 'Image Game Reply Create - Select Profile Viewed',
  }, // [이미지 게임 - 응답 생성] 유저 선택 화면 조회
  IMAGE_GAME_REPLY_CREATE_PROFILE_SELECT_CLICKED: {
    ga: 'image_game_reply_create_select_profile_clicked',
    amp: 'Image Game Reply Create - Profile Select Clicked',
  }, // [이미지 게임 - 응답 생성] 유저 선택
  IMAGE_GAME_REPLY_CREATE_QUESTIONNAIRE_VIEWED: {
    ga: 'image_game_reply_create_questionnaire_visit',
    amp: 'Image Game Reply Create - Questionnaire Viewed',
  }, // [이미지 게임 - 응답 생성] 질문지 화면 조회
  IMAGE_GAME_REPLY_CREATE_ANSWER_SELECT_CLICKED: {
    ga: 'image_game_reply_create_answer_clicked',
    amp: 'Image Game Reply Create - Answer Select Clicked',
  }, // [이미지 게임 - 응답 생성] 답변 선택
  IMAGE_GAME_REPLY_CREATE_REPLY_CREATE_SUBMIT: {
    ga: 'image_game_reply_create_question_edit_clicked',
    amp: 'Image Game Reply Create - Reply Create Submit',
  }, // [이미지 게임 - 응답 생성] 응답 생성 완료
  IMAGE_GAME_HOST_DETAIL_VIEWED: {
    ga: 'image_game_host_detail_visit',
    amp: 'Image Game Host Detail - Viewed',
  }, // [이미지 게임 - 호스트 퀴즈 디테일] 화면 조회
  IMAGE_GAME_HOST_DETAIL_KAKAO_SHARE_CLICKED: {
    ga: 'image_game_host_detail_kakao_clicked',
    amp: 'Image Game Host Detail - Kakao Share Clicked',
  }, // [이미지 게임 - 호스트 퀴즈 디테일] 카카오 공유 클릭
  IMAGE_GAME_HOST_DETAIL_LINK_COPY_CLICKED: {
    ga: 'image_game_host_detail_copy_link_clicked',
    amp: 'Image Game Host Detail - Link Copy Clicked',
  }, // [이미지 게임 - 호스트 퀴즈 디테일] 공유 링크 복사 클릭
  IMAGE_GAME_HOST_DETAIL_SEE_RESULT_CLICKED: {
    ga: 'image_game_host_detail_see_result_clicked',
    amp: 'Image Game Host Detail - See Result Clicked',
  }, // [이미지 게임 - 호스트 퀴즈 디테일] ‘결과 보기’ 클릭
  IMAGE_GAME_HOST_DETAIL_RESULT_QUESTIONNAIRE_VIEWED: {
    ga: 'image_game_host_detail_questionnaire_visit',
    amp: 'Image Game Host Detail - Result Questionnaire Viewed',
  }, // [이미지 게임 - 호스트 퀴즈 디테일] 결과 질문지 화면 조회
  IMAGE_GAME_HOST_DETAIL_RESULT_NEXT_CLICKED: {
    ga: 'image_game_host_detail_next',
    amp: 'Image Game Host Detail - Result Next Clicked',
  }, // [이미지 게임 - 호스트 퀴즈 디테일] 결과 질문지 화면에서 ‘다음’ 버튼 클릭
  IMAGE_GAME_HOST_DETAIL_RESULT_PREVIOUS_CLICKED: {
    ga: 'image_game_host_detail_prev',
    amp: 'Image Game Host Detail - Result Previous Clicked',
  }, // [이미지 게임 - 호스트 퀴즈 디테일] 결과 질문지 화면에서 ‘이전’ 버튼 클릭
  IMAGE_GAME_HOST_DETAIL_START_NEW_GAME_CLICKED: {
    ga: 'image_game_host_detail_start_new_game_clicked',
    amp: 'Image Game Host Detail - Start New Game Clicked',
  }, // [이미지 게임 - 호스트 퀴즈 디테일] 결과 질문지 화면에서 ‘새 게임 시작하기’ 버튼 클릭
  IMAGE_GAME_GUEST_DETAIL_VIEWED: {
    ga: 'image_game_guest_detail_visit',
    amp: 'Image Game Guest Detail - Viewed',
  }, // [이미지 게임 - 게스트 퀴즈 디테일] 화면 조회
  IMAGE_GAME_GUEST_DETAIL_KAKAO_SHARE_CLICKED: {
    ga: 'image_game_guest_detail_kakao_clicked',
    amp: 'Image Game Guest Detail - Kakao Share Clicked',
  }, // [이미지 게임 - 게스트 퀴즈 디테일] 카카오 공유 클릭
  IMAGE_GAME_GUEST_DETAIL_LINK_COPY_CLICKED: {
    ga: 'image_game_guest_detail_copy_link_clicked',
    amp: 'Image Game Guest Detail - Link Copy Clicked',
  }, // [이미지 게임 - 게스트 퀴즈 디테일] 공유 링크 복사 클릭
  IMAGE_GAME_GUEST_DETAIL_SEE_RESULT_CLICKED: {
    ga: 'image_game_guest_detail_see_result_clicked',
    amp: 'Image Game Guest Detail - See Result Clicked',
  }, // [이미지 게임 - 게스트 퀴즈 디테일] ‘결과 보기’ 클릭
  IMAGE_GAME_GUEST_DETAIL_RESULT_QUESTIONNAIRE_VIEWED: {
    ga: 'image_game_guest_detail_questionnaire_visit',
    amp: 'Image Game Guest Detail - Result Questionnaire Viewed',
  }, // [이미지 게임 - 게스트 퀴즈 디테일] 결과 질문지 화면 조회
  IMAGE_GAME_GUEST_DETAIL_RESULT_NEXT_CLICKED: {
    ga: 'image_game_guest_detail_next',
    amp: 'Image Game Guest Detail - Result Next Clicked',
  }, // [이미지 게임 - 게스트 퀴즈 디테일] 결과 질문지 화면에서 ‘다음’ 버튼 클릭
  IMAGE_GAME_GUEST_DETAIL_RESULT_PREVIOUS_CLICKED: {
    ga: 'image_game_guest_detail_prev',
    amp: 'Image Game Guest Detail - Result Previous Clicked',
  }, // [이미지 게임 - 게스트 퀴즈 디테일] 결과 질문지 화면에서 ‘이전’ 버튼 클릭
  IMAGE_GAME_GUEST_DETAIL_START_NEW_GAME_CLICKED: {
    ga: 'image_game_guest_detail_start_new_game_clicked',
    amp: 'Image Game Guest Detail - Start New Game Clicked',
  }, // [이미지 게임 - 게스트 퀴즈 디테일] 결과 질문지 화면에서 ‘새 게임 시작하기’ 버튼 클릭
  IMAGE_GAME_QUIZ_CREATE_FINISH_NOW_CLICKED: {
    ga: 'image_game_quiz_create_finish_now_clicked',
    amp: 'Image Game Quiz Create - Finish Now Clicked',
  }, // [이미지 게임 - 퀴즈 생성] 지금 생성 완료하기 버튼 클릭
}
